import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useIsMobile } from "../../../hooks/useMediaQuery";
import { CALENDAR_ENTRY_KINDS } from "../../../constants/calendarSessionTypes";
import aa from "../AdminPortal/adminApp.module.css";

export default function CalendarCreateKindSheet({ open, onClose, onPick }) {
  const isMobile = useIsMobile(768);
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      className={`${aa.calSheetBackdrop} ${isMobile ? "" : aa.calKindBackdropCenter}`}
      onClick={onClose}
      role="presentation"
    >
      <div
        className={`${aa.calKindSheet} ${isMobile ? "" : aa.calKindSheetCenter}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Что добавить в календарь"
      >
        {isMobile ? <div className={aa.calSheetHandle} aria-hidden /> : null}
        <header className={aa.calCreateHead}>
          <h2 className={aa.calCreateTitle}>Что добавить?</h2>
          <button
            type="button"
            className={aa.calSheetClose}
            onClick={onClose}
            aria-label="Закрыть"
          >
            <svg viewBox="0 0 24 24" aria-hidden>
              <path
                d="M6 6l12 12M18 6 6 18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </header>
        <div className={aa.calKindList}>
          {CALENDAR_ENTRY_KINDS.map((item) => (
            <button
              key={item.id}
              type="button"
              className={aa.calKindOption}
              onClick={() => onPick(item.id)}
            >
              <span className={aa.calKindIcon} aria-hidden>
                {item.icon}
              </span>
              <span className={aa.calKindText}>
                <strong>{item.label}</strong>
                <span>{item.hint}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  );
}
